import {connect} from 'react-redux';
import './PropertyInsightsAug2020.scss';
// Using lazy loaded component to help with page load
import PropertyInsightsAug2020 from './PropertyInsightsAug2020.lazy';
import {getIsFieldVisible, isNZLocale} from 'lib/PropertyUtils';
import {setDisplayField} from 'actionCreators/comparableSales';
import AnalyticsGateway from 'lib/AnalyticsGateway';

const firstListingField = 'firstPublishedPrice';
const lastListingField = 'latestPublishedPrice';

const mapStateToProps = (state, ownProps) => {
  const { propertyId, displayFields } = ownProps;
  const isNZ = isNZLocale();
  const isFirstListingVisible = getIsFieldVisible(firstListingField, displayFields);
  const isLastListingVisible = getIsFieldVisible(lastListingField, displayFields);

  return {
    ...ownProps,
    isNZ,
    isFirstListingVisible,
    isLastListingVisible,
    firstListingUpdateFields: [firstListingField],
    lastListingUpdateFields: [lastListingField],
    property: {
      propertyId: propertyId,
      [firstListingField]: ownProps[firstListingField],
      [lastListingField]: ownProps[lastListingField],
    },
  };
};

const mapDispatchToProps = (dispatch, {propertyId}) => {
  const onFirstListingClick = (event) => {
    dispatch(setDisplayField({
      propertyId,
      fieldName: firstListingField,
      descriptiveFieldName: AnalyticsGateway.descriptiveFieldNames[firstListingField],
      visible: event.target.checked,
    }));
  };
  const onLastListingClick = (event) => {
    dispatch(setDisplayField({
      propertyId,
      fieldName: lastListingField,
      descriptiveFieldName: AnalyticsGateway.descriptiveFieldNames[lastListingField],
      visible: event.target.checked,
    }));
  };

  return {
    onFirstListingClick,
    onLastListingClick,
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
  };
};

const PropertyInsightsAug2020Container = connect(mapStateToProps, mapDispatchToProps, mergeProps)(PropertyInsightsAug2020);

export { PropertyInsightsAug2020Container, PropertyInsightsAug2020 };
export default PropertyInsightsAug2020Container;